import { render } from "./vendor-login.vue?vue&type=template&id=0475e93d&scoped=true"
import script from "./vendor-login.vue?vue&type=script&lang=js"
export * from "./vendor-login.vue?vue&type=script&lang=js"

import "./vendor-login.vue?vue&type=style&index=0&id=0475e93d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0475e93d"]])

export default __exports__